import { FC, useCallback, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import UrlView from './Url';

/**
 * Keeps URL presentations alive across navigation when `leaveOpen` is set.
 * The active URL presentation is always rendered; others stay mounted (hidden) only if they asked to.
 * @returns {JSX.Element} Component template
 */
const UrlHost: FC = () => {
  const { pathname } = useLocation();
  const [keepAlive, setKeepAlive] = useState<string[]>([]);
  const activeId = matchPath("/device/:deviceId/url/:documentId", pathname)?.params?.documentId;

  const handleLeaveOpen = useCallback((documentId: string, leaveOpen: boolean) => {
    setKeepAlive(prev => {
      const isKept = prev.includes(documentId);
      if (leaveOpen === isKept) { return prev; }
      return leaveOpen ? [...prev, documentId] : prev.filter(id => id !== documentId);
    });
  }, []);

  const mountedIds = Array.from(new Set([...keepAlive, ...(activeId ? [activeId] : [])]));

  return (
    <>
      {mountedIds.map(id => (
        <UrlView key={`url-${id}`} documentId={id} active={id === activeId} onLeaveOpen={handleLeaveOpen}/>
      ))}
    </>
  );
};

export default UrlHost;
